import { render, staticRenderFns } from "./CuponsPorClienteChart.vue?vue&type=template&id=45836886"
import script from "./CuponsPorClienteChart.vue?vue&type=script&lang=js"
export * from "./CuponsPorClienteChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports